import {
  axiosInstance
} from './axiosInstance';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

export const getDirectorDetails = async (businessId) => {
  let response;
  try {
    if (businessId) {
      response = await axiosInstance.get(`/business/${businessId}/directors`);
    } else {
      response = [];
    }

  } catch (err) {
    response = handleErrorResponse(err);
  }

  return response;
};

export const putDirectorDetails = async (data) => {
  let response;
  const businessId = localStorage.getItem('businessId');
  try {
    response = await axiosInstance.put(`/business/${businessId}/directors`, data);
  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};

export const postDirectorDetails = async (data) => {
  let response;
  let businessId =localStorage.getItem('businessId');

  try {
    response = await axiosInstance.post('/director-verification', { ...data, 'businessId': businessId });
  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};

export const deleteDirectorDetails = async (data) => {

  let response;
  let businessId = localStorage.getItem('businessId');

  try {
    response = await axiosInstance.delete(`business/${businessId}/director/${data?.directorId}`);
  } catch (err) {
    response = handleErrorResponse(err, data);
  }

  return response;
};
